import { useTranslation } from "react-i18next";
import { Card, Col, Row } from "reactstrap";
import i18n from "i18next";

export function CustomReimbursementCommentView({dataComment, editMode, onClickDelete, onClickEdit, embedded = false }) {
    const { t } = useTranslation();

    const isReadOnlyProceeding = editMode === undefined && !onClickDelete && !onClickEdit;

    if (isReadOnlyProceeding && embedded) {
        if (!dataComment || dataComment.length === 0) return null;

        return (
            <div style={{ marginTop: 14 }}>
                <div className="reimbursement-section-subtitle">Kommentar</div>

                <div className="reimbursement-fields" style={{ gap: 10 }}>
                    {dataComment.map((item, index) => (
                        <div key={`comment-embedded-${item?.id ?? index}`} className="reimbursement-field">
                            <div className="reimbursement-field-value" style={{ fontWeight: 600 }}>
                                {item?.comment || "-"}
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        );
    }

    return (
        <>        
            {dataComment && dataComment.length > 0 ? (
                dataComment.map((item, index) => (
                    <Col lg={12} key={`participant${index}`} className="mt-1">
                        <Card className="bg-card-grey p-3">
                            <Row>
                                <Col lg={12}>
                                    <Row className="d-flex align-items-center">
                                        <Col xxl={item.status !== 'Förslag' || editMode ? 12 : 9} className="order-1 order-xxl-0 pe-3">
                                            <Row className="d-flex align-items-center">
                                                    <Row className="align-items-center mb-2">
                                                <Col xs={4} md={3} className="text-start">
                                                    <span className="fw-bold">{i18n.t('modelLabel.comment')}</span>:
                                                </Col>
                                                <Col xs={8} md={9} className="d-flex justify-content-center">
                                                    {item.comment && (
                                                    <div>
                                                        {item.comment}
                                                    </div>
                                                    )}
                                                </Col>
                                                </Row>
                                            </Row>
                                        </Col>
                                    </Row>
                                    
                                </Col>
                            </Row>
                        </Card>
                    </Col>
                ))
            ) : null}
        </>
    );
}
